function validEmail(email){
   var emailPattern = /^[a-z0-9_-][a-z0-9._-]*@[a-z0-9.-]+\.[a-z]{2,4}$/i;
   return emailPattern.test(email);
}

function formError (error, element){
    $(".form-errors").removeClass("display-none").addClass("display-inline");
    if (error.charAt(error.length-1)!='.') error+='.';
    $(".actual-errors").append("<div style='padding-top: 3px;'>"+error+"</div>");
    if (element) element.addClass("redback");
}

function clearError(){
    $(".redback").removeClass("redback");
    $(".form-errors").removeClass("display-inline").addClass("display-none");
    $(".form-success").removeClass("display-inline").addClass("display-none");
    $('.actual-errors').empty();
}

function explodeName(name, form){
    name = $.trim(name);
    if((space=name.indexOf(" ")) != -1){
            $(form).find('#first_name').val(name.substr(0,space));
            $(form).find('#last_name').val(name.substr(space,name.length-1));
    }else{
        $(form).find('#first_name').val(name);
        $(form).find('#last_name').val("");
    }
}
    
$(document).ready(function(){
    $("label").inFieldLabels();
    $('form').attr('autocomplete','off');
});

$('form').submit(function(){
    clearError(); var err = 0; var elm = null;
    switch($(this).find('.form-submit').attr('value'))
    { 
        case 'LOGIN':
            if(!validEmail((elm=$(this).find('#customer_email_login')).val())){
                formError("- The email address is invalid.",elm); err = 1;
            }
            if((elm=$(this).find('#customer_password_login')).val().length<5){
                formError("- The password is too short (min. 5 characters).",elm); return false;
            }
            break;
        case 'RECOVER':
            if(!validEmail((elm=$(this).find('#customer_email_recover')).val())){
                formError("- The email address is invalid.",elm); return false;
            }
            break;
        case 'REGISTER': 
            if((name=(elm=$(this).find('#customer_name_register')).val()).length==0){
                formError("- The name field is empty.",elm); err = 1;
            } else explodeName(name,this);
            if(!validEmail((elm=$(this).find('#customer_email_register')).val())){
                formError("- The email address is invalid.",elm); err = 1;
            }
            if((elm=$(this).find('#customer_password_register')).val().length<5){
                formError("- The password is too short (min. 5 characters).",elm); return false;
            }
            if($(this).find('#customer_password_register').val()!==(elm=$(this).find('#customer__confirm_password_register')).val()){
                formError("- The passwords do not match.",elm); return false;
            }
            break;
       case 'RESET': 
            if((elm=$(this).find('#customer_password')).val().length<5){
                formError("- The password is too short (min. 5 characters).",elm); return false;
            }
            if($(this).find('#customer_password').val()!==(elm=$(this).find('#customer_password_confirmation')).val()){
                formError("- The passwords do not match.",elm); return false;
            }
            break;
        default:
    } if (err) return false; return true;
});

$(".login-toggler").click(function () {
  $(".login-display").toggleClass("display-none");
});